import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import type { Listing } from "@/types";
import { Sticker } from "@/components/Doodles";
import { StatusPill } from "@/components/StatusPill";

export function ListingCard({ listing, index }: { listing: Listing; index: number }) {
  return (
    <Link
      to={`/admin/listings/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="paper-card group block overflow-hidden fade-up transition-transform duration-200 hover:-translate-y-1"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="relative aspect-[5/4] bg-[#F3EEE3]">
        {listing.thumbnail_path ? (
          <img src={fileUrl(listing.thumbnail_web_path || listing.thumbnail_path)} alt={listing.name} className="h-full w-full object-cover" loading="lazy" />
        ) : (
          <div className="flex h-full items-center justify-center text-sm font-semibold text-[#23324A]/50">
            {listing.status === "building" ? "Building printables…" : "No thumbnail yet"}
          </div>
        )}
        <div className="absolute left-3 top-3"><StatusPill status={listing.status} testId={`listing-status-${listing.id}`} /></div>
      </div>
      <div className="p-4">
        <div className="mb-2 flex items-start justify-between gap-3">
          <h3 className="font-display text-lg font-extrabold leading-tight text-[#23324A]">{listing.name}</h3>
          <span className="font-display text-lg font-black text-[#F08A6C]" data-testid={`listing-price-${listing.id}`}>${listing.price.toFixed(2)}</span>
        </div>
        <p className="mb-3 text-xs text-[#23324A]/60">{listing.components.length} printables · US Letter + A4</p>
        <div className="flex flex-wrap gap-2">
          {listing.categories.map((c, i) => <Sticker key={c} label={c} tilt={i % 2 ? 2 : -2} />)}
        </div>
        {listing.error && <p className="mt-3 text-xs font-semibold text-[#C2412D]" data-testid={`listing-error-${listing.id}`}>{listing.error}</p>}
      </div>
    </Link>
  );
}
